var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('div',{staticClass:"container pb-5"},[_c('b-row',[_c('b-col',{attrs:{"cols":"12"}},[_c('strong',[_vm._v("BaseUrl:")]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.licenseDetails.baseUrl))]),_vm._v(" "),_c('strong',[_vm._v("Version:")]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.licenseDetails.version))])])],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-77076a25","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/License.vue
// module id = null
// module chunks = 